/**
 * IM聊天窗口
 * author: jiaheming
 * date: 2019/06/12
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
// import actions from '../../actions';
// import {closeChat} from '../../actions/actionCreators';
import config from '../../config';
import util from '../../utils';
import createMessageList from '../common/MessageList';
import { ConnectedMessage, TimestampStyle } from '../IMMobile/Message';
import { ChatHeader } from './IMHeader';
import InputEditor from './InputEditor';

const ChatWindow = styled.div`
    position: absolute;
    left: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: rgba(238, 238, 238, 1);
    z-index: 11;
    transition: all 0.5s;
    padding-bottom: 1px;

    &.show {
        left: 0;
        transition: all 0.5s;
    }
`;
const MessageWindow = styled.div`
    flex: 1 1 auto;
    padding: 18px 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
`;

function IMChat(props) {
    const MessageList = createMessageList(ConnectedMessage, TimestampStyle);
    return (
        <ChatWindow className={props.showChat ? 'show' : ''}>
            <ChatHeader title={props.toName} />
            <MessageWindow id="wusong-im-chat-list">
                <MessageList type="session" to={props.to} getHistoryMsgs={props.getHistoryMsgs} />
            </MessageWindow>
            <InputEditor
                type="session"
                scene={props.scene}
                to={props.to}
                btnCustomComponent={props.btnCustomComponent}
            />
        </ChatWindow>
    );
}

IMChat.propTypes = {
    showChat: PropTypes.bool.isRequired,
    scene: PropTypes.string,
    to: PropTypes.string,
    customComponent: PropTypes.node,
};

function mapStateToProps(store) {
    const { imStore, showChat, customerServiceAccount } = store[config.reduxStoreName];
    const sessionId = imStore.currSessionId;
    const params = util.parseSession(sessionId);

    if (showChat && params) {
        const userInfo = imStore.userInfos[params.to] || {};
        return {
            scene: params.scene,
            to: params.to,
            toName: util.getFriendAlias(userInfo) || '',
            showChat,
        };
    } else {
        return {
            toName: '',
            showChat: false,
        };
    }
}

export default connect(mapStateToProps)(IMChat);
